export default "__VITE_ASSET__SGyCb6UL__"